/** Modus WC button colors — callers must also pass an explicit `variant`. */
export enum BtnClasses {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Warning = 'warning',
  Danger = 'danger',
}

export type AlertRole = 'alert' | 'alertdialog' | 'status';
